/**
 * @author Mevan Nirosh
 * @version 1.0
 * @since 06/26/2023
 */

import axios from "axios"

const axiosAuthApiInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_URL,
  headers: {
    "Accept-Version": "2.0",
  },
})
export default axiosAuthApiInstance
